interface Action {
    payload: any,
    type: string
}

const StatesReducer = (state = [], action: Action) => {
    switch (action.type) {
        case 'GET_STATES':
            return action.payload;
        default:
            return state;
    }
};

export default StatesReducer;
